<!--
 * @Author: your name
 * @Date: 2021-04-22 11:44:15
 * @LastEditTime: 2021-07-30 19:33:45
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \yijiu_shopmall_h5\src\views\bindingBank.vue
-->

<template>
  <div class="real-name">
    <div class="real-main">
      <van-field v-model="name" placeholder="请输入开户人姓名" label="开户人姓名" />
      <van-field value="身份证" readonly label="证件类型" />
      <van-field v-model="identity_card_no" type="tel" placeholder="请输入身份证号" label="证件号" />
      <van-field value="储蓄卡" readonly label="银行卡类型" v-if="bankType == ''" />
      <van-field name="radio" label="银行卡类型" v-if="bankType == 'rule'">
        <template #input>
          <van-radio-group v-model="bank_type" direction="horizontal">
            <van-radio name="1" checked-color="#ee0a24">储蓄卡</van-radio>
            <van-radio name="2" checked-color="#ee0a24">信用卡</van-radio>
          </van-radio-group>
        </template>
      </van-field>
      <van-field v-model="card_no" placeholder="输入银行卡号" label="银行卡号" />
      <van-field v-model="validate" placeholder="输入有效期" label="有效期" v-if="bank_type == 2" />
      <van-field v-model="cvv2" placeholder="输入安全码" label="安全码" v-if="bank_type == 2" />
      <van-field v-model="phone" type="tel" placeholder="输入银行预留手机号" label="预留手机号" />
      <div class="code">
        <van-field maxlength="6" v-model="code" type="tel" label="短信验证码" placeholder="请输入验证码" />
        <div class="obtain-code" @click="getcode()" v-if="sign == false">发送验证码</div>
        <div class="obtain-code" v-else style="text-align: center; color:#999 ">{{ codehtml }}S</div>
      </div>
    </div>
    <div class="save-real" @click="submit">提交</div>

    <!-- 加载中-->
    <div class="lodding_l" v-show="isloading">
      <van-loading type="spinner" color="#99999" />
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { Dialog, Toast, Loading } from 'vant'

Vue.use(Toast)
Vue.use(Loading)

export default {
  name: 'realName',
  data() {
    return {
      isloading: false, //加载中
      name: '', //银行看name
      card_no: '', //卡号
      phone: '', //手机号
      code: '',
      sign: false, //是否点击获取验证码按钮
      time: '', //倒计时
      isClick: false,
      codehtml: '',
      tonglianInfo: {},
      identity_card_no: '',
      bank_type: '1',
      validate: '',
      cvv2: '',
    }
  },
  watch: {
    bank_type: function (val) {
      this.phone = ''
      this.card_no = ''
      this.code = ''
      this.validate = ''
      this.cvv2 = ''
      console.log(val)
    },
  },
  created() {
    console.log(this.$route.query)
    this.identity_card_no = this.$route.query.identity_card_no
    this.name = this.$route.query.name
    if (this.$route.query.user && this.$route.query.user == 'rule') {
      this.bankType = this.$route.query.user
    } else {
      this.bankType = ''
    }
  },
  mounted() {
    this.prohibitweixinShare()
  },
  methods: {
    // 获取验证码
    getcode() {
      if (this.name == '') {
        Toast('请输入开户人姓名')
        this.isClick = false
      } else if (this.card_no == '') {
        Toast('请输入银行卡号')
        this.isClick = false
      } else if (!/^1[3456789]\d{9}$/.test(this.phone)) {
        Toast('请输入正确手机号')
        return false
      } else {
        this.isloading = true
        this.http('MemberAuth.applyBindBankCard', {
          phone: this.phone,
          name: this.name,
          card_no: this.card_no,
          validate: this.validate,
          bank_type: this.bank_type,
          cvv2: this.cvv2,
          type:
            this.$route.query.user && this.$route.query.user == 'rule'
              ? '2'
              : '1',
        }).then((res) => {
          if (res.status == 200) {
            this.isloading = false
            this.tonglianInfo = res.content
            Toast('发送成功')
            this.codehtml = 60
            this.sign = true
            let tim = setInterval(() => {
              this.codehtml = this.codehtml - 1
              if (this.codehtml <= 0) {
                clearInterval(tim)
                this.sign = false
                return false
              }
            }, 1000)
            this.time = tim
          } else {
            this.isloading = false
            Toast(res.msg)
          }
        })
      }
    },

    //提交绑定银行卡
    submit() {
      if (this.name == '') {
        Toast('请输入开户人姓名')
        this.isClick = false
        return
      }
      if (this.identity_card_no == '') {
        Toast('请输入证件号')
        return
      }
      if (this.card_no == '') {
        Toast('请输入银行卡号')
        this.isClick = false
        return
      }
      if (!/^1[3456789]\d{9}$/.test(this.phone)) {
        Toast('请输入正确手机号')
        return false
      }
      this.isloading = true
      if (this.isClick == false) {
        if (this.code == '') {
          Toast('请输入验证码')
          this.isloading = false
          this.isClick = false
        } else {
          this.http('MemberAuth.bindBankCard', {
            phone: this.phone,
            bank_id: this.tonglianInfo.bank_id,
            trance_num: this.tonglianInfo.trance_num,
            code: this.code,
            type:
              this.$route.query.user && this.$route.query.user == 'rule'
                ? '2'
                : '1',
          }).then((res) => {
            if (res.status == 200) {
              if (this.$route.query.user && this.$route.query.user == 'rule') {
                this.$router.replace({
                  path: '/ConfirmOrder',
                })
              } else {
                this.$router.push({
                  path: '/my',
                  // query: { bank_id: this.tonglianInfo.bank_id },
                })
              }
            } else {
              Toast(res.msg)
            }
            this.isloading = false
          })
        }
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.real-name {
  width: 100vw;
  min-height: 100vh;
  background: #f8f8f8;
  .real-main {
    border-top: 20px solid #f8f8f8;
  }
  .code {
    position: relative;
    width: 750px;
    height: 88px;
    .obtain-code {
      width: 160px;
      height: 100%;
      position: absolute;
      right: 30px;
      top: 0;
      font-size: 28px;
      font-weight: 400;
      color: #f0240e;
      line-height: 88px;
    }
  }
  .save-real {
    width: 686px;
    height: 96px;
    background: #ee0a24;
    border-radius: 48px;
    font-size: 32px;
    font-weight: 400;
    color: #ffffff;
    line-height: 96px;
    text-align: center;
    margin: 158px auto;
  }
}
</style>